import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d28da75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work-content" }
const _hoisted_2 = { class: "work-space" }
const _hoisted_3 = { class: "space-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "device-tip" }, "延时期间,空间相关设备会开启", -1))
const _hoisted_5 = {
  class: "add-time",
  id: "addTimeId"
}
const _hoisted_6 = {
  key: 0,
  class: "date_box"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "sliders-list",
  id: "sliderListId"
}
const _hoisted_9 = { class: "sliders" }
const _hoisted_10 = ["onClick", "data-index"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "start",
  id: "startId"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "end-box",
  id: "endBoxId"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "end",
    id: "endId"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "end-radio",
    id: "endRadioId"
  })
], -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "add-time-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.spaceInfo.spaceName) + " 申请延时", 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.dateArr && _ctx.dateArr.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateArr, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["date-item", item.isActive ? 'date-item-active' : '']),
                onClick: _withModifiers(($event: any) => (_ctx.checkDate(item, index)), ["stop"]),
                key: 'date' + index
              }, [
                _createElementVNode("span", null, _toDisplayString(item.week), 1),
                _createElementVNode("span", null, _toDisplayString(item.day), 1)
              ], 10, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nowTimerArr, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'slider' + index,
            class: "sliders-wrapper",
            id: "slidersWrapperId"
          }, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("div", { class: "label" }, _toDisplayString(item.timer), 513), [
                [_vShow, index === 0 || index % 2 === 0]
              ]),
              _createElementVNode("div", {
                class: "slider-box",
                onClick: ($event: any) => (_ctx.checkSlider(item, index)),
                "data-index": index
              }, null, 8, _hoisted_10)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "slider-btn",
          id: "sliderBtnId",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerDelTime && _ctx.triggerDelTime(...args)))
        }, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: "cancel-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeWorkTimer && _ctx.closeWorkTimer(...args)))
      }, "取消"),
      _createElementVNode("div", {
        class: _normalizeClass(["comfirm-btn", _ctx.formBtn ? 'comfirm-btn-diabled' : '']),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addWorkTimer && _ctx.addWorkTimer(...args)))
      }, " 提交申请 ", 2)
    ]),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          class: "temp-loading"
        }))
      : _createCommentVNode("", true)
  ]))
}